import * as React from "react";
import { css, cx } from "emotion";
export const defaultProps = {
    fluid: false,
};
const containerClass = css({
    "&:before, &:after": {
        content: '" "',
        display: "table",
    },
    "&:after": {
        clear: "both",
    },
    boxSizing: "border-box",
    marginRight: "auto",
    marginLeft: "auto",
    paddingLeft: "15px",
    paddingRight: "15px",
    "@media (min-width: 544px !default):": {
        maxWidth: "570px !default",
    },
    "@media (min-width: 768px !default)": {
        maxWidth: "740px !default",
    },
    "@media (min-width: 992px !default)": {
        maxWidth: "960px !default",
    },
    "@media (min-width: 1200px !default)": {
        maxWidth: "1170px !default",
    },
});
const containerFluidClass = css({
    "&:before, &:after": {
        content: '" "',
        display: "table",
    },
    "&:after": {
        clear: "both",
    },
    boxSizing: "border-box",
    marginRight: "auto",
    marginLeft: "auto",
    paddingLeft: "15px",
    paddingRight: "15px",
});
const sizeClassesX = {
    sm: css({
        paddingLeft: "2.5px",
        paddingRight: "2.5px",
    }),
    base: css({
        paddingLeft: "5px",
        paddingRight: "5px",
    }),
    md: css({
        paddingLeft: "10px",
        paddingRight: "10px",
    }),
    lg: css({
        paddingLeft: "15px",
        paddingRight: "15px",
    }),
    xl: css({
        paddingLeft: "20px",
        paddingRight: "20px",
    }),
    xxl: css({
        paddingLeft: "25px",
        paddingRight: "25px",
    }),
};
const sizeClassesY = {
    sm: css({
        paddingTop: "2.5px",
        paddingBottom: "2.5px",
    }),
    base: css({
        paddingTop: "5px",
        paddingBottom: "5px",
    }),
    md: css({
        paddingTop: "10px",
        paddingBottom: "10px",
    }),
    lg: css({
        paddingTop: "15px",
        paddingBottom: "15px",
    }),
    xl: css({
        paddingTop: "20px",
        paddingBottom: "20px",
    }),
    xxl: css({
        paddingTop: "25px",
        paddingBottom: "25px",
    }),
};
const sizeClassesSpaceBetween = {
    sm: css({
        "> :not(:last-child)": {
            marginBottom: "2.5px",
        },
    }),
    base: css({
        "> :not(:last-child)": {
            marginBottom: "5px",
        },
    }),
    md: css({
        "> :not(:last-child)": {
            marginBottom: "10px",
        },
    }),
    lg: css({
        "> :not(:last-child)": {
            marginBottom: "15px",
        },
    }),
    xl: css({
        "> :not(:last-child)": {
            marginBottom: "20px",
        },
    }),
    xxl: css({
        "> :not(:last-child)": {
            marginBottom: "25px",
        },
    }),
};
export const Container = (props) => {
    const classes = [props.fluid ? containerFluidClass : containerClass];
    props.paddingX && classes.push(sizeClassesX[props.paddingX]);
    props.paddingY && classes.push(sizeClassesY[props.paddingY]);
    props.spaceBetween &&
        classes.push(sizeClassesSpaceBetween[props.spaceBetween]);
    return React.createElement("div", { className: cx(classes) }, props.children);
};
Container.defaultProps = defaultProps;
export default Container;
//# sourceMappingURL=container.js.map